module.exports = __webpack_public_path__ + "img/breadcrumb.2df4ea3a.svg";